<template>
  <section aria-labelledby="primary-details-heading" class="container mx-auto p-5">
    <div class="flex flex-wrap items-center gap-2 mb-2">
      <h1 id="primary-details-heading" class="text-lg font-medium leading-6 text-gray-900 text-primary mr-2">
        PRIMARY DETAILS
      </h1>
      <button
        ref="editDetailsButton"
        @click="editDetails(true)"
        type="button"
        class="mb-2 inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-white cobalt-button-color hover:!bg-[#A63A1D] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
      >
        <i class="fa fa-pencil-square-o mr-1 w-4" aria-hidden="true"></i>
        Edit Details
      </button>
    </div>
    <hr />
    <div class="no-wrap md:-mx-2 mt-2">
      <!-- Left Side -->
      <div class="w-full md:flex-row flex-col xl:flex">
        <div class="md:w-full xl:w-3/12">
          <h2 class="text-primary font-bold text-xl leading-8 my-1 ml-1">
            {{ profile_data?.first_name }} {{ profile_data?.last_name }}
          </h2>
          <ul
            class="border-2 bg-white border-[#d9f9f9] text-gray-600 hover:text-gray-700 hover:shadow py-2 px-3 mt-3 divide-y rounded shadow-md xl:h-52 md:h-34"
          >
            <li class="flex items-center py-3">
              <span class="text-primary">Status</span>
              <span class="ml-auto">
                <span
                  v-if="profile_data?.status == 'Active'"
                  class="bg-green-200 py-1 px-2 rounded text-green-800 font-semibold text-sm text-primary"
                  >{{ profile_data?.status }}</span
                >
                <span
                  v-if="profile_data?.status == 'Pending'"
                  class="bg-blue-200 py-1 px-2 rounded text-blue-800 font-semibold text-sm text-primary"
                  >{{ profile_data?.status }}</span
                >
                <span
                  v-if="profile_data?.status == 'Void'"
                  class="bg-gray-200 py-1 px-2 rounded text-gray-800 font-semibold text-sm text-primary"
                  >{{ profile_data?.status }}</span
                >
                <span
                  v-if="profile_data?.status == 'Inactive'"
                  class="bg-yellow-200 py-1 px-2 rounded text-yellow-800 font-semibold text-sm text-primary"
                  >{{ profile_data?.status }}</span
                >
                <span
                  v-if="profile_data?.status == 'Terminated'"
                  class="bg-red-200 py-1 px-2 rounded text-red-800 font-semibold text-sm text-primary"
                  >{{ profile_data?.status }}</span
                ></span
              >
            </li>
            <li class="flex items-center py-3">
              <span class="text-primary">Member since</span>
              <span class="ml-auto text-primary">{{
                setDateFormat(profile_data?.date_created)
              }}</span>
            </li>
          </ul>
        </div>
        <div class="my-2 md:mx-2 xl:mx-0"></div>

        <div
          class="bg-white md:w-full xl:w-9/12 p-3 shadow-md rounded-sm xl:ml-5 xl:mt-12 md:mt-5 border-2 border-[#d9f9f9]"
        >
          <div
            class="flex items-center space-x-2 font-semibold text-gray-900 leading-8"
          >
            <span clas="text-green-500">
              <i class="fa fa-user-o"></i>
            </span>
            <span class="tracking-wide text-primary">
              <h3 class="text-base font-semibold inline">About</h3>
            </span>
          </div>
          <div class="text-gray-700">
            <div class="grid md:grid-cols-1 xl:grid-cols-2 text-sm">
              <div class="grid grid-cols-2">
                <div class="px-4 py-2 font-semibold text-primary">First Name</div>
                <div class="px-4 py-2 break-words text-primary">{{ profile_data?.first_name }}</div>
              </div>
              <div class="grid grid-cols-2">
                <div class="px-4 py-2 font-semibold text-primary">Last Name</div>
                <div class="px-4 py-2 break-words text-primary">{{ profile_data?.last_name }}</div>
              </div>
              <div class="grid grid-cols-2">
                <div class="px-4 py-2 font-semibold text-primary">Middle Name</div>
                <div class="px-4 py-2 text-primary">{{ profile_data?.middle_name }}</div>
              </div>
              <div class="grid grid-cols-2">
                <div class="px-4 py-2 font-semibold text-primary">Salutation</div>
                <div class="px-4 py-2 text-primary">{{ profile_data?.salutation }}</div>
              </div>
              <div class="grid grid-cols-2">
                <div class="px-4 py-2 font-semibold text-primary">Firm Name</div>
                <div class="px-4 py-2 text-primary">{{ profile_data?.firm_name }}</div>
              </div>
              <div class="grid grid-cols-2">
                <div class="px-4 py-2 font-semibold text-primary">Office Hours</div>
                <div class="px-4 py-2 text-primary">{{ profile_data?.office_hours }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="my-2 "></div>
      </div>
      <!-- Right Side -->
      <div class="w-full md:flex-row flex-col xl:flex md:mt-5 xl:mt-0">
        <div
          class="bg-white md:w-full xl:w-6/12 p-3 shadow-md rounded-sm xl:mt-5 border-2 border-[#d9f9f9]"
        >
          <div
            class="flex items-center space-x-2 font-semibold text-gray-900 leading-8"
          >
            <span clas="text-green-500">
              <i class="fa fa-address-book-o"></i>
            </span>
            <span class="tracking-wide text-primary">
              <h3 class="text-base font-semibold inline">Address Details</h3>
            </span>
          </div>
          <div class="text-gray-700">
            <ul class="list-inside space-y-2">
              <li
                class="mt-2"
                v-for="(address, i) in profile_data?.addresses"
                :key="i"
              >
                <div class="text-teal-600 uppercase" v-if="address?.type?.name">
                  {{ address.type["name"] }}
                </div>
                <div
                  class="text-teal-600 uppercase"
                  v-if="!address?.type?.name"
                >
                  {{ address.type }}
                </div>
                <div class="text-primary">
                  <p>{{ address.address1 }},</p>
                  <p v-if="address.address2 != null && address.address2 != ''">
                    {{ address.address2 }},
                  </p>
                  <p>{{ address.city }} - {{ address.zip }},</p>
                  <p>{{ address.county }}, {{ address.state }}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="my-2 md:mx-2 xl:mx-0"></div>
        <div
          class="bg-white md:w-full xl:w-6/12 p-3 shadow-md border-2 rounded-sm xl:mt-5 xl:ml-5 border-[#d9f9f9]"
        >
          <div
            class="flex items-center space-x-2 font-semibold text-gray-900 leading-8"
          >
            <span clas="text-green-500">
              <i class="fa fa-user"></i>
            </span>
            <span class="tracking-wide text-primary">
              <h3 class="text-base font-semibold inline">Contact Details</h3>
            </span>
          </div>
          <div class="contacts-block contacts-block--attorney mt-3">
            <div
              v-for="(contact, i) in displayContacts"
              :key="i"
              class="contact-card"
              :class="{ 'contact-card--first': getContactType(contact) === 'Primary' }"
            >
              <div class="contact-card__header">
                <span class="contact-card__title">{{ getContactCardTitle(contact, i) }}</span>
              </div>
              <div class="contact-card__body">
                <div class="grid grid-cols-12 gap-x-4 contact-card__row contact-card__row--primary-fields">
                  <div class="col-span-12 md:col-span-9 contact-field">
                    <span class="contact-field-label">Name</span>
                    <span class="contact-read-value">{{ contact?.name || "—" }}</span>
                  </div>
                </div>
                <div class="grid grid-cols-12 gap-x-4 contact-card__row contact-card__row--details">
                  <div class="col-span-12 sm:col-span-6 md:col-span-4 contact-field">
                    <span class="contact-field-label">Email</span>
                    <span class="contact-read-value break-all">{{ contact?.email || "—" }}</span>
                  </div>
                  <div class="col-span-6 md:col-span-2 contact-field">
                    <span class="contact-field-label">Telephone</span>
                    <span class="contact-read-value">{{ contact?.phone || "—" }}</span>
                  </div>
                  <div class="col-span-6 md:col-span-2 contact-field">
                    <span class="contact-field-label">Cell Phone</span>
                    <span class="contact-read-value">{{ contact?.cell || "—" }}</span>
                  </div>
                  <div class="col-span-6 md:col-span-2 contact-field">
                    <span class="contact-field-label">Ext</span>
                    <span class="contact-read-value">{{ contact?.ext || "—" }}</span>
                  </div>
                  <div class="col-span-6 md:col-span-2 contact-field">
                    <span class="contact-field-label">Fax</span>
                    <span class="contact-read-value">{{ contact?.fax || "—" }}</span>
                  </div>
                  <div class="col-span-6 md:col-span-2 contact-field">
                    <span class="contact-field-label">Note</span>
                    <span class="contact-read-value">{{ contact?.note || "—" }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="my-2"></div>
      </div>
    </div>
    <div v-if="editModalOpen" id="primary_detail" class="edit-profile">
      <div
        ref="primaryDetailModal"
        tabindex="0"
        role="dialog"
        aria-modal="true"
        aria-label="Edit Details"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed"
        @keydown="onModalKeydown"
      >
        <div class="z-50 relative p-1 mx-auto my-0  max-w-full xl:w-4/5 md:w-full">
          <div class="bg-white px-4 mt-2 pt-5 pb-4 sm:p-4 sm:pb-1 rounded-lg">
            <div
              class="flex flex-row justify-between p-1 bg-white border-b border-gray-200 rounded-tl-lg rounded-tr-lg"
            >
              <p class="font-semibold text-gray-800 p-1">Edit Details</p>
              <button
                type="button"
                class="fa fa-close w-6 h-6 cursor-pointer"
                aria-label="Close Edit Details dialog"
                @click="editDetails(false)"
              ></button>
            </div>
            <div class="flex flex-col">
              <app-primary class="editprofile-popup-scroll"
               ref="child_comp_0" :forms="form"></app-primary>
              <button
                type="button"
                @click="updateAttorney()"
                class="self-end md:w-1/6 w-full mb-2 mr-5 mt-6 rounded-md group relative flex justify-center py-3 px-3 border border-transparent text-md font-medium text-white cobalt-button-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-50"
              >
                <i
                  class="fa fa-pencil-square-o mr-1 mt-1"
                  aria-hidden="true"
                ></i>
                <span>Save</span>
              </button>
            </div>
          </div>
        </div>
        <div
          class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
        ></div>
      </div>
    </div>
  </section>
</template>

<script>
import AppPrimary from "./AppPrimary.vue"; // importing resuable input field
import { mapState } from "vuex"; // importing mapState for get access state level variables.
import $ from "jquery";
import Constants from "../../constants.ts"; // importing constant resubale variables.

import {
  getContactCardTitle,
  getContactType,
  normalizeContactsForForm,
} from "../../utils/contactHelpers.js";

export default {
  name: "PrimaryDetails",
  props: ["forms"],
  data: function() {
    // declaring static variable for this component
    return {
      setDateFormat:Constants.setDateFormat,
      form: this.forms,
      editModalOpen: false,
      cloneData:{
        firstName:"",
        lastName:"",
        middleName:"",
        firmName:"",
        officeHours:"",
        contacts:"",
        addresses:"",
      }
    };
  },
  // use to import central level variables from store
  computed: {
    ...mapState(["profile_data"]),
    displayContacts() {
      return normalizeContactsForForm(this.profile_data?.contacts || []);
    },
  },
  //importing resuable components to use in current component
  components: {
    AppPrimary,
  },
  created() {
    this.$store.watch(
      () => this.$store.state.is_attorney_updated,
      (value) => {
        if (value === true) {
          this.editModalOpen = false;
        }
      }
    );
  },
  methods: {
    getContactType,
    getContactCardTitle,
    updateAttorney: function() {
      this.$refs["child_comp_0"].submitApplication();
      if (
        this.$refs["child_comp_0"].v$.form.$pending ||
        this.$refs["child_comp_0"].v$.form.$error
      ) {
        this.$toast.error("please fill required fields!");
        return;
      }
      if (!this.$refs["child_comp_0"].prepareContactsForSubmit()) {
        return;
      }
      var updatedData = {
        ...this.form,
        contacts: this.form.contacts,
        update_key: "UPDATE_PRIMARY_DETAILS",
      };
      this.$store.dispatch("updateAttorneyData", {
        data: updatedData,
      });
    },
    editDetails: function(value) {
      if (value) {
        this.editModalOpen = true;
        this.$nextTick(() => {
          $("#primary_detail div").animate({ scrollTop: 0 }, 1000);
          this.focusFirstInModal();
          for (let index = 0; index < this.form?.addresses?.length; index++) {
            setTimeout(() => {
              const el = document.getElementById("address_" + index);
              if (el) el.value = this.form.addresses[index].address1;
            }, 1000);
          }
        });
      } else {
        this.editModalOpen = false;
        this.$store.dispatch("getAttProfileData");
        this.$nextTick(() => {
          const btn = this.$refs.editDetailsButton;
          if (btn && typeof btn.focus === "function") btn.focus();
        });
      }
    },
  },
};
</script>
